import React from "react";

import UiContext from "../../../context/UiContext";
import { Button } from "../../Button";

import styles from "./InfoDialog.module.css";

export const InfoDialog: React.FC = () => {
  const { closeDialog } = React.useContext(UiContext);

  return (
    <div className={styles.wrapper}>
      <img src="/images/pin-large.svg" alt="innspel" className={styles.image} />

      <h2>Vi ønskjer dine innspel!</h2>
      <p className="faded">
        Foreslå eit kulturminne, eller sjå og støtt andre sine forslag!
      </p>

      <div className={styles.footer}>
        <Button onClick={() => closeDialog()} width="full">
          Sett i gang →
        </Button>
      </div>
    </div>
  );
};
